module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-cleared"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Level " + _vm._s(_vm.$store.state.level) + " Cleared.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$store.state.bonusScore))]), _vm._v(" bonus points")]), _vm._v(" "), _c('p', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.nextLevel
    }
  }, [_vm._v("Next Level")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/scramble-logo.png"),
      "title": "logo",
      "alt": "logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c697a18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LevelCleared.vue
// module id = 26
// module chunks = 0